import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=e345b530&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=js"
export * from "./Tag.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Tag.vue?vue&type=style&index=0&id=e345b530&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e345b530",
  null
  ,true
)

export default component.exports